import * as types from './types'

/**
 * The read's rows, with the generation the request started under: the
 * reducer drops them if a write has bumped it since (utils/generation.ts).
 * Same shape as the deal / facility / entity grid reads.
 */
export const getTodos = (todos: any[], generation?: number) => ({
  type: types.GET_TODOS,
  payload: { todos, generation },
})
export const todosLoadFailed = () => ({
  type: types.TODOS_LOAD_FAILED,
  payload: null,
})

export const getTodo = (payload: any) => ({
  type: types.GET_TODO,
  payload,
})

export const addTodo = (payload: any) => ({
  type: types.ADD_TODOS,
  payload,
})

export const editTodo = (payload: any) => ({
  type: types.EDIT_TODOS,
  payload,
})

export const deleteTodos = (payload: any) => ({
  type: types.DELETE_TODOS,
  payload,
})

export const startLoadingTodos = () => ({
  type: types.START_LOADING_TODOS,
  payload: null,
})

export const stopLoadingTodos = () => ({
  type: types.STOP_LOADING_TODOS,
  payload: null,
})
